const style = (theme) => {
  const output = {
    root: {
      fontSize: 14,
      display: 'inline-block',
      padding: '16px 28px',
      borderRadius: 10,
      color: theme.colors[1],
      background: theme.colors[2],
      verticalAlign: 'middle',
      transition: `background .3s ${theme.easings['power4.out']}, color .3s ${theme.easings['power4.out']}`,
      cursor: 'pointer',
      '& span': {
        display: 'block',
        lineHeight: 1.3,
      },
    },
    label: {},
    btnFill: {},
    btnSlim: {
      fontSize: 10,
      textTransform: 'uppercase',
      padding: '7px 15px',
      borderRadius: 6,
      '& span': {
        lineHeight: 1,
      },
    },
    btnOrange: {
      color: theme.colors[3],
      background: 'transparent',
      border: `1px solid ${theme.colors[3]}`,
      '& svg': {
        fill: theme.colors[3],
      },
      '&:hover': {
        background: theme.colors[3],
        color: theme.colors[1],
        '& svg': {
          fill: theme.colors[1],
        },
      },
      '&$btnFill': {
        background: theme.colors[3],
        color: theme.colors[1],
        '& svg': {
          fill: theme.colors[1],
        },
        '&:hover': {
          background: 'transparent',
          color: theme.colors[3],
          '& svg': {
            fill: theme.colors[3],
          },
        },
      },
    },
    btnLight: {
      color: theme.colors[1],
      background: 'transparent',
      border: `1px solid ${theme.colors[1]}`,
      '& svg': {
        fill: theme.colors[1],
      },
      '&:hover': {
        background: theme.colors[1],
        color: theme.colors[3],
        '& svg': {
          fill: theme.colors[3],
        },
      },
      '&$btnFill': {
        background: theme.colors[1],
        color: theme.colors[3],
        '& svg': {
          fill: theme.colors[3],
        },
        '&:hover': {
          background: 'transparent',
          color: theme.colors[1],
          '& svg': {
            fill: theme.colors[1],
          },
        },
      },
    },
    withIcons: {
      display: 'flex',
      alignItems: 'center',
      '& > a': {
        display: 'flex',
        alignItems: 'center',
      },
      '& svg': {
        fill: 'currentColor',
        height: 15,
        width: 15,
        transition: `fill .3s ${theme.easings['power4.out']}`,
        '&.download': {
          transform: 'rotate(-90deg)',
        },
      },
      '& $label': {
        marginLeft: 10,
      },
    },
    onlyIcons: {
      padding: 16,
    },
  }

  return output
}

export default style
